<template>
  <div id="page-churabou">
    <img>
    <top-column></top-column>
    <sns-field class="sns-field"></sns-field>
  </div>
</template>

<script>

import TopColumn from '@/components/TopColumn'
import SnsField from '@/components/SnsField'

export default {
  name: 'churabou',
  components: {
    TopColumn,
    SnsField
  }
}

</script>

<style scoped>


#page-churabou img {
  height: auto;
  text-align: center;
  background: linear-gradient(cyan, yellow);
}

/*  モバイルなら*/
@media screen and (max-width:781px) {
  #page-churabou img  {
    width: 100%;
    height: 200px;
  }
  .sns-field {
    display: none;
  }
}

/*  WEBなら*/
@media screen and (min-width:781px) {
  #page-churabou img  {
    width: 90%;
    height: 600px;
  }
  .sns-field {
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Churabou.vue